import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { NewRequestChooser, MyRequestsView } from "@/components/StaffRequestWidgets";
import { Plus } from "lucide-react";

// Chauffeur : « Congés & demandes » — nouvelle demande (congé / acompte / RDV interne / diverse) + mes demandes en cours / traitées.
export default function Leaves() {
  const nav = useNavigate();
  const [st, setSt] = useState(null);
  const [leaves, setLeaves] = useState([]);
  const [staff, setStaff] = useState([]);
  const [open, setOpen] = useState(false);
  const load = (s) => {
    if (s.enabled) api.get("/leaves/mine").then((r) => setLeaves(r.data)).catch(() => {});
    if (s.staff_requests_enabled) api.get("/staff-requests/mine").then((r) => setStaff(r.data)).catch(() => {});
  };
  useEffect(() => { api.get("/leaves/module-status").then((r) => { if (!r.data.enabled && !r.data.staff_requests_enabled) { toast.error("Module Congés & demandes non activé"); nav("/driver", { replace: true }); } else { setSt(r.data); load(r.data); } }).catch(() => {}); }, [nav]);
  if (!st) return null;
  return (
    <div className="space-y-5 pb-6" data-testid="driver-leaves-page">
      <div className="flex items-start justify-between gap-2"><div><p className="text-xs font-semibold tracking-widest uppercase text-accent-700">Congés & demandes</p><h1 className="text-2xl font-heading font-extrabold text-brand-900 mt-0.5">Mes demandes</h1></div>
        <button data-testid="leave-new-button" onClick={() => setOpen(!open)} className="h-11 px-4 rounded-xl bg-accent-600 text-white font-bold text-sm inline-flex items-center gap-1.5"><Plus className="w-4 h-4" />Nouvelle demande</button></div>
      {open && <NewRequestChooser st={st} isAdmin={false} prefix="driver-new" onCreated={() => { setOpen(false); load(st); }} />}
      <MyRequestsView leaves={leaves} staff={staff} onChanged={() => load(st)} prefix="my" />
    </div>
  );
}
